import { render } from "./Customers.vue?vue&type=template&id=2ee85092&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=2ee85092&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee85092"]])

export default __exports__